export const localizedField = (item, field, locale = 'es') => {
    const value = item?.[field]
    if (!value) return null
    if (typeof value === 'string') return value
    const code = locale === 'en' ? 'en' : 'es'
    return value[code] || value.es || null
}

export const tutorialsFrom = (config, { feature = null, screen = null, accountType = null } = {}) => {
    if (!config?.active) return []
    const items = config.items || {}
    return Object.keys(items)
        .map(slug => ({ slug, ...items[slug] }))
        .filter(item => item.active !== false)
        .filter(item => !feature || item.feature === feature)
        .filter(item => !screen || !item.screens?.length || item.screens.includes(screen))
        .filter(item => !accountType || !item.accountTypes?.length || item.accountTypes.includes(accountType))
        .sort((a, b) => (a.order || 0) - (b.order || 0))
}
